import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { BotonTipo } from '../../../components/boton/boton';

import { PropuestasService } from '../../../providers/propuestas.service';
import { UsuarioService } from '../../../providers/usuario.service';
import { EditarClasificacionDatosDialogComponent } from './editar-clasificacion-datos-dialog/editar-clasificacion-datos-dialog.component';
import { ClasificacionDatosService } from '../../../providers/clasificacion-datos.service';
// import { EditarGrupoUsuariosDialog } from './editar-grupo-usuarios-dialog/editar-grupo-usuarios-dialog.component';
// import { EditarFlujoTrabajoDialog } from './editar-flujo-trabajo-dialog/editar-flujo-trabajo-dialog.component';

@Component({
  selector: 'app-editar-clasificacion-datos',
  templateUrl: './editar-clasificacion-datos.component.html',
  styleUrls: ['./editar-clasificacion-datos.component.scss']
})
export class EditarClasificacionDatosComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() curso?: any;
  @Input() disabled: boolean = false;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter(); 

  constructor(
    public dialog: MatDialog,
    // public contactosSv: ContactoService,
    private cursosSv: ClasificacionDatosService,
    public usuarioSv: UsuarioService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() { 
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
    if (!this.curso) {
      throw "La variable Input 'contacto' es requerida";
    }
  }

  openDialog(): void {
    let dialogEditar = this.dialog.open(EditarClasificacionDatosDialogComponent, {
      disableClose: true,
      data: {
        curso: this.curso
      }
    });

    dialogEditar.afterClosed().subscribe(cursoEditado => {
      if (cursoEditado) {
        console.log('Aca esta el curso editado', cursoEditado);
        this.cursosSv.editarClasificacion(cursoEditado.id, cursoEditado.estado, cursoEditado.descripcion).subscribe(
          respuesta => {
            if(respuesta.estado == 1){
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.onCerrado.emit();
            }else{
              this.snackBar.open(respuesta.mensaje, '', { duration: 2750 });
              return;
            }
          }, () => {

          }
        )

      } 
    });
  }
}
